import { render, staticRenderFns } from "./bigScreenExamJump.vue?vue&type=template&id=04b43e6e&scoped=true"
import script from "./bigScreenExamJump.vue?vue&type=script&lang=js"
export * from "./bigScreenExamJump.vue?vue&type=script&lang=js"
import style0 from "./bigScreenExamJump.vue?vue&type=style&index=0&id=04b43e6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b43e6e",
  null
  
)

export default component.exports